import axiosInstance from "../utils/axios";

export const testimonyService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/testimoni", {
      params,
    });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get("/testimoni/" + id);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/testimoni", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/testimoni/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/testimoni/${id}`);
    return response.data;
  },
};
